import React, {Component, Fragment} from 'react';
import ReadyButton from '../../components/ReadyButton';
import AudioPlayer from '../../components/AudioPlayer';

import om_introNo from '../../assets/sounds/no/intros/oneMinute-intro.mp3';
import om_introSe from '../../assets/sounds/se/intros/oneMinute-intro.mp3';
import om_introDe from '../../assets/sounds/de/intros/oneMinute-intro.wav';
import om_introDeChild from '../../assets/sounds/de/intros/oneMinute-intro-child.mp3';
import om_introDeAdult from '../../assets/sounds/de/intros/oneMinute-intro-adult.mp3';

import strings from '../../strings';

class Intro extends Component {
	constructor(props) {
		super(props);

		switch (strings.getLanguage()) {
			case 'nn':
				// Nynorsk currently uses the Swedish follow-up intro audio.
				// falls through
			case 'se':
				this.om_intro = om_introSe;
				break;
			case 'de':
				switch (this.props.testKeyType) {
					case 'child-followup':
						this.om_intro = om_introDeChild;
						this.introtext1 = strings.om_intro_child;
						this.introtext2 = strings.om_intro_child2;
						this.introtext3 = strings.om_intro_child3;
						break;
					case 'adult-followup':
						this.om_intro = om_introDeAdult;
						this.introtext1 = strings.om_intro_adult;
						this.introtext2 = strings.om_intro_adult2;
						this.introtext3 = strings.om_intro_adult3;
						break;
					default:
						this.om_intro = om_introDe;
						this.introtext1 = strings.om_intro;
						this.introtext2 = '';
						this.introtext3 = '';
						break;
				}

				break;

			case 'no':
			default:
				this.om_intro = om_introNo;
				break;
		}
	}

	render() {
		const {testKeyType = null} = this.props;
		const isAdultFollowup = testKeyType === 'adult-followup';
		return (
			<Fragment>
				<p>
					<AudioPlayer autoplay inline src={this.om_intro} />
					{this.introtext1}
				</p>
				<p>{this.introtext2}</p>
				<p>{this.introtext3}</p>
				<ReadyButton
					onReadyChange={this.props.setReady}
					isSpoonerism={false}
					isAdultTest={isAdultFollowup}
				/>
			</Fragment>
		);
	}
}

export default Intro;
